import {SiteType} from '@wp-content-publisher/typings-lib/dist/src/server/types/site.ts';
import {apiRequest} from '../../../shared/utils/api-request.helper.ts';


export const removeSite = async (id: number): Promise<SiteType[]> =>
    await apiRequest({
        url: `/sites/${id}`,
        options: {method: 'DELETE'}
    });